export default __webpack_public_path__ + "static/media/service-details.0bdffc99.png";